module.exports = __webpack_public_path__ + "static/img/蒙版组 34.ee8494d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/images/蒙版组 34.png
// module id = 02Xs
// module chunks = 0